module.exports = __webpack_public_path__ + "static/red1-36d07b25550ee0f22866e0639288904f.png";